var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"turnstile-widget"},[_c('div',{ref:"container"}),(_vm.failed)?_c('p',{staticClass:"turnstile-error"},[_vm._v(" Verification could not load. Please refresh the page and try again. ")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }